export default {
       common: {
           unit: 'USDT',
           day: 'ngày',
           week: 'tuần',
           save: 'Lưu',
           submit: 'Gửi đi',
           confirmtitle: 'Xác nhận thực hiện',
           confirm: 'Xác nhận',
           reset: 'Đặt lại',
           refresh: 'Làm mới',
           copy: 'Sao chép',
           copysuccessful: 'Sao chép thành công',
           modify: 'Sửa đổi',
           binding: 'Liên kết',
           finished: 'Đã hoàn thành',
           canceled: 'Đã hủy',
           cancel: 'Hủy bỏ',
           all: 'Tất cả',
           back: 'Quay lại',
           loading: 'Đang tải...',
           nomore: 'Tất cả bản ghi',
           errortxt: 'Tải thất bại',
           loosing: 'Thả để làm mới...',
           pulling: 'Kéo xuống để làm mới...',
           nodata: 'Chưa có bản ghi',
           buy: 'Mua vào',
           buyup: 'Mua tăng',
           buydown: 'Mua giảm',
           sell: 'Bán ra',
           forserver: 'Vui lòng liên hệ CSKH',
           total: 'Tổng cộng',
           status1: 'Chờ duyệt ',
           status2: 'Hoàn thành ',
           status3: 'Không được duyệt',
           paytype1:'TRC20',
           paytype2: 'ERC20',
           paytype3: 'Chuyển khoản',
       },
       footer: {
           home: 'Trang chủ',
           market: 'Thị trường',
           exchange: 'Giao dịch',
           options: 'Quyền chọn',
           assets:'Tài sản',
           change: 'Chuyển đổi',
           recharge: 'Nạp tiền',
           withdrawal: 'Rút tiền'
       },
       home: {
           menu1:'GDQC',
           menu1desc: 'Hỗ trợ BTC/USDT...',
           menu2: 'Nạp tiền nhanh',
           menu3: 'Rút tiền',
           menu4: 'CSKH trực tuyến',
           menu5: 'Đổi nhanh',
           menu6: 'Vay hỗ trợ',
           menu7: 'Khai thác khóa',
           menu8: 'Staking',
           menu9: 'Chuyển khoản',
           ranktitle: 'Bảng xếp hạng tăng giá',
           name: 'Tên',
           price: 'Giá mới nhất',
           risefall: 'Tỷ lệ tăng giảm',
       },
       register: {
           register: 'Đăng ký',
           login: 'Đăng nhập',
           email: 'Email',
           phone: 'Số điện thoại',
           accountplaceholder: 'Vui lòng nhập tài khoản',
           emailplaceholder: 'Vui lòng nhập email',
           phoneplaceholder: 'Vui lòng nhập số điện thoại',
           pwdplaceholder:'Vui lòng nhập mật khẩu',
           pwdplaceholder1:'Mật khẩu từ 6-20 ký tự chữ số',
           agepwdplaceholder: 'Vui lòng nhập lại mật khẩu',
           agepwdplaceholder1: 'Hai mật khẩu không khớp',
           invitecodeplaceholder: 'Vui lòng nhập mã mời',
           remember: 'Ghi nhớ mật khẩu',
           fotget: 'Quên mật khẩu'
       },
       market:{
           title: 'Thị trường',
           all: 'Tất cả'
       },
       member:{
           reputation:'Điểm uy tín',
           identity_authentication:'Xác thực danh tính',
           under_review:'Đang xét duyệt',
           certified:'Đã xác thực',
           awaiting_certification:'Chờ xác thực',
           binding_withdrawal_address: 'Liên kết địa chỉ rút tiền',
           currently_selected_currency:'Đồng tiền đã chọn',
           withdrawal_address:'Địa chỉ rút tiền',
           sharing_link:'Link chia sẻ của tôi',
           my_promotion_code:'Mã giới thiệu của tôi',
           promotion_code:'Mã giới thiệu',
           system_message:'Thông báo hệ thống',
           night_mode:'Chế độ ban đêm',
           security_center:'Trung tâm bảo mật',
           seted: 'Đã thiết lập',
           noset: 'Chưa thiết lập',
           login_password:'Mật khẩu đăng nhập',
           transaction_password:'Mật khẩu rút tiền',
           app_download:'Tải App',
           log_out:'Đăng xuất',
           aboutus: 'Giới thiệu website'
       },
       identity:{
           title: 'Xác thực danh tính',
           name: 'Họ tên',
           nameplaceholder: 'Vui lòng nhập tên thật',
           uploader: 'Tải lên ảnh CMND',
           tip1: 'Tải lên mặt trước CMND',
           tip2: 'Tải lên mặt sau CMND'
       },
       address: {
           title: 'Liên kết địa chỉ rút tiền',
           bType: 'Đồng tiền đã chọn',
           address: 'Địa chỉ rút tiền',
           addressplaceholder:'Vui lòng nhập địa chỉ rút tiền',
       },
       security:{
           title: 'Trung tâm bảo mật',
           modifypwd: 'Mật khẩu đăng nhập',
           resetlegalpwd: 'Mật khẩu giao dịch',
           loginpwd: 'Mật khẩu đăng nhập mới',
           pwdage: 'Xác nhận mật khẩu',
           loginpwdplaceholder:'Vui lòng nhập mật khẩu đăng nhập hiện tại',
           loginnewpwdplaceholder: 'Vui lòng nhập mật khẩu đăng nhập mới',
           moneypwd: 'Vui lòng nhập mật khẩu giao dịch',
           pwdageplaceholder:'Vui lòng nhập lại mật khẩu'
       },
       trade:{
           title: 'Giao dịch tiền điện tử',
           price: 'Giá',
           num: 'Số lượng',
           entrust: 'Ủy thác hiện tại',
           clinch: 'Giao dịch thực tế',
           used: 'Khả dụng',
           buyed: 'Có thể mua',
           amount: 'Số tiền giao dịch',
           limitprice: 'Giới hạn giá',
           marketprice: 'Giá thị trường',
           forprice: 'Giao dịch với giá tốt nhất hiện tại',
           errorMoney: 'Số dư khả dụng không đủ',
           priceerror: 'Vui lòng nhập giá ủy thác',
           numerror: 'Vui lòng nhập số lượng ủy thác',
           moneyerror: 'Vui lòng nhập số tiền ủy thác',
       },
       assets:{
           allconvert:'Tổng tài sản quy đổi',
           usenum: 'Khả dụng',
           freeze: 'Đóng băng',
           convert: 'Quy đổi',
           tab1:'Tài sản',
           tab11: 'Tổng tài sản quy đổi',
           tab12: 'Quy đổi quyền chọn',
           tab13: 'Quy đổi tiền',
           tab14: 'Quy đổi định lượng',
           tab2:'Quyền chọn',
           tab21: 'Tài khoản quyền chọn',
           tab3:'Tiền',
           tab31:'Tài khoản tiền',
           tab4:'Định lượng',
           tab41:'Tài khoản định lượng',
           tbhead1: 'Lịch sử tài chính',
           tbhead2: 'Lịch sử rút tiền',
           tbhead3: 'Lịch sử nạp tiền',
           tbhead4: 'Lịch sử chuyển đổi',
           rcdnum: 'Số lượng',
           rcd: 'Ghi chép',
           rcdtime: 'Thời gian',
           rcdstatus: 'Trạng thái',
           rcddesc: 'Ghi chú',
           rcdaddress: 'Địa chỉ nạp tiền'
       },
       change:{
           title: 'Chuyển đổi',
           from: 'Từ {name}',
           to: 'Đến {name}',
           frmtitle: 'Số lượng chuyển đổi',
           inputplaceholder: 'Vui lòng nhập số lượng chuyển đổi',
           btntxt:'Chuyển đổi'
       },
       recharge:{
           title: 'Nạp tiền',
           bType: 'Đồng tiền hiện tại',
           address: 'Địa chỉ nạp tiền',
           token: 'Chứng từ thanh toán',
           tokenplaceholder: 'Vui lòng tải lên chứng từ thanh toán',
           num: 'Số lượng nạp',
           numplaceholder: 'Vui lòng nhập số lượng',
           btn: 'Gửi xét duyệt',
           bankname: 'Tên ngân hàng',
           bankno: 'Số ngân hàng',
           accountname: 'Tên tài khoản nhận',
           bankaddress: 'Địa chỉ ngân hàng',
           bankcode: 'Mã chuyển khoản ngân hàng',
           companyaddress: 'Địa chỉ công ty'
       },
       withdrawal:{
           title:'Rút tiền',
           frmtitle1: 'Số lượng',
           frmplaceholder1: 'Số lượng rút từ {min} - {max}',
           frmtitle2: 'Mật khẩu giao dịch',
           frmplaceholder2: 'Vui lòng nhập mật khẩu giao dịch',
           getnum: 'Số lượng nhận được',
           fee:'Phí giao dịch',
           btn: 'Rút tiền'
       },
       exchangeb:{
           title: 'Đổi',
           account: 'Tài khoản',
           btn: 'Đổi',
           numerror: 'Vui lòng nhập số lượng đổi'
       },
       option:{
           title: 'Quyền chọn',
           typetitle: 'Hợp đồng giây',
           listtitle: 'Vị thế',
           kline: 'Biểu đồ K',
           high: 'Cao',
           low: 'Thấp',
           nums: 'Khối lượng 24H',
           time: 'Thời gian',
           transaction: 'Chế độ giao dịch',
           quantity: 'Số lượng mở',
           quantityerror: 'Vui lòng nhập số lượng mở',
           times: 'Thời gian mở',
           times1: 'Thời gian thanh toán',
           account: 'Số dư tài khoản',
           buyup:'Mua tăng',
           buydown: 'Mua giảm',
           tab1: 'Danh sách vị thế',
           tab2: 'Lịch sử đơn hàng',
           num: 'Số lượng',
           price1: 'Giá mua',
           price2: 'Giá thực hiện',
           profitandloss: 'Lãi/lỗ dự kiến',
           profitandloss1: 'Lãi/lỗ',
           countdown: 'Đếm ngược',
           waitfinish: 'Chờ thanh toán',
           finishing: 'Đang thanh toán...',
           finished: 'Đã thanh toán',
           order_price: 'Giá hiện tại',
           order_cycle: 'Chu kỳ',
           order_type: 'Loại',
           order_money: 'Số tiền',
           order_time: 'Thời gian mở',
           order_get: 'Lợi nhuận',
           order_btn: 'Tiếp tục đặt lệnh'
       },
       tradelst:{
           title: 'Ủy thác của tôi',
           tab1: 'Ủy thác',
           tab2: 'Hoàn thành giao dịch',
           tab3: 'Đã hủy',
           usdtnum: ''
       },
       loans:{
           title: 'Vay hỗ trợ',
           order_tab: 'Đơn vay',
           pro_tab: 'Sản phẩm vay',
   
           Institution:'Tổ chức cho vay',
           Amount: 'Số tiền',
           DailyInterest:'Lãi suất ngày',
           RepaymentPeriod:'Kỳ hạn trả nợ',
           Application: 'Đăng ký vay',
           orderno: 'Số đơn hàng',
           AllInterest: 'Tổng lãi',
           RepaymentDate:'Ngày trả nợ',
           RepaymentMethod: 'Phương thức trả nợ',
           Onetime: 'Một lần',
           Expected_loan_amount:'Số tiền muốn vay',
           Expected_loan_amounterror:'Số tiền vay từ {min} - {max}',
           imgplaceholdr: 'Cho vay tín dụng (Đảm bảo hình ảnh rõ ràng)',
           icon1: 'Tải lên mặt trước giấy tờ',
           icon2: 'Tải lên mặt sau giấy tờ',
           icon3: 'Tải lên ảnh cầm giấy tờ',
           status1: 'Đang đăng ký',
           status2: 'Đăng ký thành công',
           status3: 'Đăng ký thất bại',
       },
       lockming:{
           title: 'Khai thác khóa',
           order_tab: 'Đơn đặt máy đào',
           pro_tab: 'Thị trường máy đào',
           locknum: 'Số lượng khóa tối thiểu',
           getforday: 'Tỷ suất lợi nhuận/ngày',
           days: 'Số ngày',
           estimation: 'Lợi nhuận dự kiến',
           real: 'Đã nhận lợi nhuận',
           balance: 'Số dư ví',
           nums: 'Số lượng khóa',
           tolockming: 'Khóa',
           stime: 'Thời gian bắt đầu',
           etime: 'Thời gian kết thúc',
       },
       transfer:{
           title: 'Chuyển khoản tài khoản',
           searchtxt: 'Vui lòng nhập tài khoản người nhận',
           ReceivingAccount: 'Thông tin tài khoản nhận',
           toaccount: 'Tài khoản',
           confirmtxt: 'Vui lòng xác nhận tài khoản nhận',
           confirmedtxt: 'Đã xác nhận tài khoản nhận',
           numtxt: 'Số lượng chuyển khoản',
           numerror: 'Vui lòng nhập số lượng chuyển khoản',
           fee: 'Miễn phí chuyển khoản nội bộ',
           ArrivalTime: 'Thời gian nhận',
           Immediately: 'Nhận ngay lập tức',
           realnum: 'Số lượng thực nhận',
           btn: 'Xác nhận chuyển khoản',
   
           transfering: 'Đang chuyển',
           orderNo: 'Số đơn hàng',
           stime: 'Thời gian chuyển',
           etime: 'Thời gian nhận',
           receiving: 'Tài khoản nhận',
           type: 'Loại tiền',
           num: 'Số lượng chuyển',
           arrivalnum: 'Số lượng nhận'
       },
       staking:{
           title: 'Staking',
           record: 'Ghi chép',
           getforyear: 'Lợi nhuận năm tham khảo',
           time: 'Thời hạn đầu tư',
           snum: 'Số lượng tối thiểu',
           snumerror: 'Vui lòng nhập số lượng tối thiểu',
           snumerror1: 'Số lượng tối thiểu không dưới {num}',
           join: 'Tham gia ngay',
           opentime: 'Thời gian mở',
           money: 'Số tiền đầu tư',
           days: 'Chu kỳ',
           recordget: 'Lợi nhuận năm',
           gets: 'Lợi nhuận',
           stime: 'Ngày bắt đầu',
           etiem: 'Ngày kết thúc',
           redeemStaking: 'Hủy bỏ',
           status0: 'Đang staking',
           status1: 'Đơn hàng kết thúc',
           status2: 'Đơn hàng đã rút',
       },
       bank:{
           title: 'Liên kết thẻ ngân hàng',
           bankName: 'Tên ngân hàng',
           bankNameError: 'Vui lòng nhập tên ngân hàng',
           usrName: 'Chủ thẻ',
           usrNameError: 'Vui lòng nhập tên chủ thẻ',
           cardCode: 'Số thẻ ngân hàng',
           cardCodeError: 'Vui lòng nhập số thẻ ngân hàng',
           towallet: 'Rút về ví',
           tobank: 'Rút về thẻ ngân hàng',
           sendcode: 'Gửi mã xác thực',
           sended: 'Gửi lại sau {num} giây',
           verify_code: 'Vui lòng nhập mã xác thực email'
       },
       other:{
    welcome: 'Xin chào, chào mừng đến với {name}',
    homeaboutustitle: 'Nền tảng giao dịch tài sản kỹ thuật số toàn cầu hàng đầu',
    homeaboutustitle1: 'Bảo mật',
    homeaboutusdesc1: 'Hợp tác với nhiều t tổ chức bảo mật hàng đầu để đảm bảo giao dịch an toàn và hiệu quả',
    homeaboutustitle2: 'Dịch vụ khách hàng 24/7',
    homeaboutusdesc2: 'Hỗ trợ trực tuyến 24 giờ, sẵn sàng đáp ứng nhu cầu của bạn',
    homeaboutustitle3: 'Phủ sóng toàn cầu',
    homeaboutusdesc3: 'Cộng đồng quốc tế, phủ sóng 205 quốc gia/vùng lãnh thổ, h hỗ trợ 11 ngôn ngữ, 19 cộng đồng quốc gia/khu vực, 5 triệu người dùng đăng ký',
    totrade: 'Bắt đầu giao dịch',
    toregister: 'Bắt đầu hành trình tiền điện tử',
    yingli: 'Lợi nhuận hôm nay',
    kuisun: 'Lỗ hôm nay',
    agree: 'Tôi đã đọc và đồng ý',
    useragreement: 'Thỏa thuận người dùng',
    account: 'Tài khoản',
    pwd: 'Mật khẩu',
    toregister1: 'Chưa đăng ký',
    loginbtn: 'Đăng nhập',
    registerbtn: 'Đăng ký ngay',
    tologin: 'Đã có tài khoản? Đến trang đăng ký',
    allrevenue: 'Tổng doanh thu',
    stakingcount: 'Đơn đặt hàng Staking',
    stakingamount: 'Số tiền Staking',
    todayincome: 'Ước tính hôm nay'

       }
   }
   